import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-12 h-12 flex items-center justify-center">
            <img 
              src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/9369c4398e685bc93ca98dee52c77f48.png" 
              alt="Kent Zimmerman" 
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-xl font-light tracking-wide text-gray-900">
            Kent Zimmerman
          </span>
        </Link>
        <div className="flex items-center gap-8">
          <Link to="/" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            Home
          </Link>
          <Link to="/about" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            About
          </Link>
          <Link to="/books" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            Books
          </Link>
          <Link to="/artwork" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            Artwork
          </Link>
          <Link to="/audiobooks" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            Audiobooks
          </Link>
          <Link to="/contact" className="text-sm font-light tracking-wide text-gray-900 hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer">
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}
